import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';
import { EventDialogs } from '../../constants/Dialogs';

import TableView from '../Common/TableView';
import AddEntityActionButton from '../Common/AddEntityActionButton';
import EventAttendeeTableRow from './EventAttendeeTableRow';
import EventAttendanceDialog from './EventAttendanceDialog';
import EmailAttendeesDialog from '../Message/BulkEmailDialog';
import ErrorSnackbar from '../Common/ErrorSnackbar';
import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';

import InfoIcon from 'material-ui/svg-icons/action/info';
import SignOutIcon from 'material-ui/svg-icons/navigation/cancel';
import EmailIcon from 'material-ui/svg-icons/communication/email';
import PrintIcon from 'material-ui/svg-icons/action/print';
import DownloadIcon from 'material-ui/svg-icons/file/file-download';
import PersonIcon from 'material-ui/svg-icons/social/person';
import UpIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import DownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';

import DialogActions from '../../actions/DialogActionCreator';
import DialogStore from '../../stores/DialogStore';
import EventActions from '../../actions/EventActionCreator';
import EventAttendeeStore from '../../stores/EventAttendeeStore';
import EventStore from '../../stores/EventStore';
import SearchStore from '../../stores/SearchStore';
import buildContextMenu from '../Common/BuildContextMenu';
import { DateStyles } from '../../constants/CentricConstants';
import { FormattedDate } from 'react-intl';

const defaultAttendance = () => ({
    userId:     null,
    title:      null,
    firstName:  null,
    lastName:   null
});

class EventAttendees extends Component {

    componentDidMount() {
        this.onEventChange = this.onEventChange.bind(this);
        this.onAddEvent = this.onAddEvent.bind(this);
        this.onRowSelection = this.onRowSelection.bind(this);
        this.openMessageDialog = this.openMessageDialog.bind(this);
        this.onSendMessages = this.onSendMessages.bind(this);
        this.loadNextPage = this.loadNextPage.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.search = this.search.bind(this);
        this.toggleSearchMode = this.toggleSearchMode.bind(this);
        this.onSearch = this.onSearch.bind(this);

        EventActions.getAttendees(this.state.eventId, { role: 'delegate' });
        // since eventstore isn't done yet:
        this.listeners = [
            EventStore.addListener(this.onEventChange),
            SearchStore.addListener(this.onSearch)
        ];
        EventActions.getById(this.state.eventId);

        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        this.listeners.forEach(listener => listener.remove());
        window.removeEventListener('scroll', this.handleScroll);
    }

    render() {
        const headers = [
            'Attendee', 'Registered', ''
        ];

        return (
            <div ref="attendeeList">
                <TableView
                    title={this.state.title}
                    subtitle={this.state.subtitle}
                    headers={headers}
                    rows={this.state.attendees}
                    decorator={EventAttendeeTableRow}
                    backButton={true}
                    multiSelectable={true}
                    enableSelectAll={true}
                    onRowSelection={this.onRowSelection}
                    actions={buildContextMenu(this.getActions(), this.context.auth)}
                    searchAction={this.search}
                    toggleSearchMode={this.toggleSearchMode}
                >
                    {this.state.loading && (
                        <LinearProgress mode="indeterminate" />
                    )}
                    {this.state.showButton && (
                        <FlatButton
                            label={this.state.fetchedAll ? 'Back to top' : 'Load more'}
                            icon={this.state.fetchedAll ? <UpIcon/> : <DownIcon/>}
                            onTouchTap={this.state.fetchedAll ? () => window.scrollTo(0, 0) : this.loadNextPage}
                            disabled={this.state.loading}
                            fullWidth
                        />
                    )}
                    {(!!this.state.eventStatus && this.state.eventStatus !== 'canceled') && (
                        <AddEntityActionButton onClick={() => DialogActions.open(EventDialogs.ATTENDEE_ADD, defaultAttendance())} />
                    )}
                    {this.getDialog()}
                    <ErrorSnackbar/>
                </TableView>
            </div>
        );
    }

    getDialog() {
        switch (this.state.dialog) {
            case EventDialogs.ATTENDEE_ADD:
                return (<EventAttendanceDialog onSave={this.onAddEvent} attendanceLocked={this.state.attendanceLocked} />);

            case EventDialogs.ATTENDEE_BULK_EMAIL:
                return (<EmailAttendeesDialog onSave={this.onSendMessages} />);

            default: break;
        }
    }

    getActions() {
        return [

            {
                link: `/dashboard/event/${this.state.eventId}`,
                icon: <InfoIcon />,
                label: 'Preview',
            },
            {
                link: `/dashboard/event/${this.state.eventId}/trainers`,
                icon: <PersonIcon />,
                label: 'Trainers',
            },
            {
                link: `/dashboard/event/${this.state.eventId}/attendees/print`,
                icon: <PrintIcon />,
                label: 'Print view',
            },
            {
                link: `/cent/event/${this.state.eventId}/attendees.csv`,
                icon: <DownloadIcon />,
                label: 'Download CSV',
                target: '_blank',
            },
            {
                type: 'divider'
            },
            {
                action: this.openMessageDialog,
                icon: <EmailIcon/>,
                label: 'Send message',
                condition: {
                    show: this.state.selected.length
                }
            },
            {
                type: 'divider'
            },
            {
                link: '/logout',
                icon: <SignOutIcon />,
                label: 'Sign out',
            },
        ];
    }

    onEventChange() {
        const event = EventStore.getById(this.state.eventId);
        if (!!event) {
            this.setState({
                title: ` ${event.name}`,
                subtitle: <div>{event.venue} - <FormattedDate {...DateStyles.shortDateTime} value={new Date(event.timeStart)}/></div>,
                eventStatus: event.status,
                attendanceLocked: event.attendanceLocked
            });
        }
    }

    onAddEvent(draft) {
        if (!draft.userId) { return; } // guard: userId exists
        const { addToWaitingList, ...params } = draft;
        if (addToWaitingList !== undefined) {
            params.status = !!addToWaitingList ? 'waiting' : 'attending';
        }
        EventActions.addAttendance(this.state.eventId, params);
    }

    openMessageDialog() {
        if (this.state.selected.length === 0) { return; } // guard
        let users;
        if (this.state.selected === 'all') {
            users = this.state.attendees;
        } else {
            users = this.state.attendees.filter((user, i) => this.state.selected.includes(i));
        }
        users = users.map(({userId, email, title, firstName, lastName}) => ({id: userId, email, name: `${title || ""} ${firstName || ""} ${lastName || ""}`.trim()}));
        DialogActions.open(EventDialogs.ATTENDEE_BULK_EMAIL, {users, subject: '', message: ''});
    }

    onSendMessages({subject, message, users}) {
        EventActions.sendEmail(this.state.eventId, subject, message, users);
    }

    onRowSelection(selected) {
        if (selected === this.state.selected) { return; } // guard
        this.setState({selected: selected !== 'none' ? selected : []});
    }

    loadNextPage() {
        if (this.state.loading) { return; } //guard

        const page = !this.state.searchMode ? (this.state.page + 1) : (this.state.searchPage + 1);
        if (!this.state.searchMode) {
            EventActions.getAttendees(this.state.eventId, {page, role: 'delegate'});
            this.setState({page});
        } else if (!!this.state.searchText) {
            EventActions.searchAttendees(this.state.eventId, this.state.searchText, {page});
            this.setState({searchPage: page});
        }
    }

    handleScroll() {
        if (!this.state.showButton && window.scrollY > 0) {
            this.setState({showButton: true});
        }
        if (!this.state.fetchedAll && (window.scrollY + window.innerHeight) >= this.refs.attendeeList.clientHeight) {
            this.loadNextPage();
        }
    }

    onSearch() {
        this.setState({
            fetchedAll: this.state.searchMode && SearchStore.fetchedAll(),
            loading: this.state.searchMode && SearchStore.isFetching()
        });
    }

    search(searchText) {
        this.timeout && clearTimeout(this.timeout);
        if (!!searchText && searchText.length > 2) {
            this.timeout = setTimeout(() => { EventActions.searchAttendees(this.state.eventId, searchText, {page: 0}); }, 500);

            this.setState({
                searchText,
                searchPage: 0,
                showButton: false,
                fetchedAll: (searchText !== this.state.searchText ? false : this.state.fetchedAll)
            });
        }
    }

    toggleSearchMode(searchMode) {
        this.setState({
            searchMode,
            fetchedAll: false,
            showButton: false,
            searchText: searchMode ? this.state.searchText : null
        });
    }
}

EventAttendees.getStores = () => ([EventAttendeeStore, DialogStore]);

EventAttendees.calculateState = (prevState, {routeParams}) => {
    const eventId = (!!prevState && prevState.eventId) || Number(routeParams.id);
    const attendees = EventAttendeeStore.getByEvent(eventId) || [];
    return {
        ...prevState,
        eventId,
        title:      (!!prevState && prevState.title) || 'Attendance',
        subtitle:   (!!prevState && prevState.subtitle) || 'Event',
        selected:   (!!prevState && prevState.selected) || [],
        attendees,
        dialog:     DialogStore.getOpenDialog(),
        eventStatus: (!!prevState && prevState.eventStatus) || null,
        page:       (!!prevState && prevState.page) || 0,
        searchPage: (!!prevState && prevState.searchPage) || 0,
        searchMode: (!!prevState && prevState.searchMode) || false,
        searchText: (!!prevState && prevState.searchText) || null,
        loading:    EventAttendeeStore.isFetching(),
        fetchedAll: EventAttendeeStore.fetchedAll(),
        showButton: !!prevState && prevState.showButton
    };
};

EventAttendees.contextTypes = {
    auth:   PropTypes.object.isRequired
};

export default Container.create(EventAttendees, {withProps: true});
